import { render, staticRenderFns } from "./RegisterList.vue?vue&type=template&id=ef24d8bc&scoped=true"
import script from "./RegisterList.vue?vue&type=script&lang=js"
export * from "./RegisterList.vue?vue&type=script&lang=js"
import style0 from "./RegisterList.vue?vue&type=style&index=0&id=ef24d8bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef24d8bc",
  null
  
)

export default component.exports